// Tiny client-side helper for the /ref/:code → /signup hand-off. The cookie
// survives navigation, refresh, and an open-in-new-tab loop; signup reads it,
// posts it with the auth body, and the server forwards it to Beehiiv as the
// referrer's referral_code so the credit lands on the right account.

const COOKIE = 'hxd_ref';
const MAX_AGE_SECONDS = 30 * 24 * 60 * 60;

export function setReferralCookie(code) {
  if (typeof document === 'undefined') return;
  const value = encodeURIComponent(String(code));
  document.cookie = `${COOKIE}=${value}; max-age=${MAX_AGE_SECONDS}; path=/; samesite=lax`;
}

export function getReferralCookie() {
  if (typeof document === 'undefined') return null;
  const m = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE}=([^;]*)`));
  if (!m) return null;
  try {
    return decodeURIComponent(m[1]);
  } catch {
    return null;
  }
}

export function clearReferralCookie() {
  if (typeof document === 'undefined') return;
  document.cookie = `${COOKIE}=; max-age=0; path=/; samesite=lax`;
}
